import r from "./index205.mjs";
import i from "./index212.mjs";
function d(a, f) {
  i(2, arguments);
  var e = r(a), t = r(f), n = e.getFullYear() - t.getFullYear(), o = e.getMonth() - t.getMonth();
  return n * 12 + o;
}
export {
  d as default
};
//# sourceMappingURL=index331.mjs.map
